import { Auth } from 'aws-amplify';
import { getRuntimeConfig } from 'vl-common/src/hooks/Runtime';

export type LogLevel = 'INFO' | 'WARN' | 'ERROR';

interface LogEntry {
  timestampMs?: number;
  logLevel?: LogLevel;
  message: string;
}

interface LogRequest {
  logs: LogEntry[];
}

export const logFeatureEvent = async (proxy: string, body: LogRequest) => {
  try {
    const currentSession = await Auth.currentSession();

    const response = await fetch(`${getRuntimeConfig().API_URL}/logs/${proxy}`, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${currentSession.getIdToken().getJwtToken()}`
      }
    });

    if (!response.ok) {
      console.warn('Feature log rejected', response.status);
    }
  } catch (error) {
    console.warn('Failed to send feature log', error);
  }
};
